<template>
  <div class="gallery">
    <aside class="gallery-scroll">
      <a
        v-for="year in years"
        :class="{ 'active': currentIntersecting ===  year }"
        :href="`#${year}`"
        :key="year"
      >
        {{ year }}
      </a>
    </aside>
    <layout-with-scrollbar>
      <div class="gallery-content">
        <template v-for="year in years">
          <div
            v-intersect="handleIntersect"
            class="gallery-intersect"
            :key="year"
            :id="year"
          >
            <div class="races-date mt-9" :id="year"  >
              <base-image :info="$app.images.badge" />
              <span :class="$app.isF1 ? 'races-year-f1' : 'races-year-nascar'">{{ year }}</span>
            </div>
            <template v-for="(racesInMonth, month) in formatedRaces[year]">
              <div class="races-date" :key="`${year}-${month}-1`">
                <img v-if="!$app.isF1" src="@/assets/images/NascarBadgeGrey.svg" alt="Nascar">
                {{ month.split('-')[1] }}
              </div>
              <div class="races-list" :key="`${year}-${month}-2`">
                <RaceCard
                  v-for="race in racesInMonth"
                  :key="race._id"
                  :race="race"
                />
              </div>
            </template>
          </div>
        </template>
      </div>
    </layout-with-scrollbar>
  </div>
</template>

<script>
import BaseImage from '@/components/BaseImage'
import LayoutWithScrollbar from '@/components/layout/LayoutWithScrollbar'
import RaceCard from './RaceCard'

export default {
  name: 'RaceGallery',
  components: {
    BaseImage,
    LayoutWithScrollbar,
    RaceCard,
  },
  props: {
    races: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentIntersecting: null,
    }
  },
  computed: {
    formatedRaces() {
      const result = {}
      for (const year in this.races) {
        result[year] = this.races[year].reduce((res, cur) => {
          const date = new Date(cur.race_date)
          const monthNumber = date.getMonth()
          const monthName = date.toLocaleString('en-GB', { month: 'long' })
          const month = `${monthNumber}-${monthName}`
          if (res[month]) {
            res[month].push(cur)
          } else {
            res[month] = [cur]
          }
          return res
        }, {})
      }
      return result
    },
    years() {
      return Object.keys(this.races).reverse()
    },
  },
  methods: {
    handleIntersect (entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.currentIntersecting = entries[0]?.target?.id
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.gallery {
  display: grid;
  grid-template-columns: 75px 1fr;
  gap: 8px;
  background: var(--v-grey-lighten-5);
}

.gallery-content {
  display: flex;
  flex-direction: column;
  margin: 0 105px 36px 40px;
}

.gallery-intersect {
  display: flex;
  flex-direction: column;
  gap: 36px;
}

.races-date {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  line-height: 24px;
  color: var(--v-grey-lighten-1);
  font-weight: 700;
}

.races-year-f1 {
  font-family: Goldman, Avenir, Helvetica, Arial, sans-serif;
  font-size: 26px;
  font-weight: 700;
}

.races-year-nascar {
  font-family: Exo, Avenir, Helvetica, Arial, sans-serif;
  font-size: 27px;
  font-weight: 700;
}

.races-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  grid-gap: 24px;
}

.gallery-scroll {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: center;
  gap: 5vh;
  font-size: 12px;

  a {
    width: 30px;
    position: relative;
    transition: 0.3s;
    color: inherit;
    line-height: 16px;

    &::before,
    &:not(:last-child)::after {
      content: '';
      position: absolute;
      height: 1px;
      transform: translateY(-50%);
      background: var(--v-grey-lighten-2);
    }

    &::before {
      width: 12px;
      left: -24px;
      top: 50%;
    }

    &:not(:last-child)::after {
      width: 24px;
      left: -24px;
      bottom: -2.5vh;
    }
  }

  .active {
    color: var(--v-secondary-base);
    font-weight: 700;

    &::before {
      background: var(--v-secondary-base);
      height: 2px;
    }
  }
}
</style>
